module.exports = __webpack_public_path__ + "img/icon-download.bc2911e0.svg";